import { render, staticRenderFns } from "./standardCard-list.vue?vue&type=template&id=c618b4f6&scoped=true"
import script from "./standardCard-list.vue?vue&type=script&lang=js"
export * from "./standardCard-list.vue?vue&type=script&lang=js"
import style0 from "./standardCard-list.vue?vue&type=style&index=0&id=c618b4f6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c618b4f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c618b4f6')) {
      api.createRecord('c618b4f6', component.options)
    } else {
      api.reload('c618b4f6', component.options)
    }
    module.hot.accept("./standardCard-list.vue?vue&type=template&id=c618b4f6&scoped=true", function () {
      api.rerender('c618b4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/standardCard-management/standardCard-list.vue"
export default component.exports